import { render, staticRenderFns } from "./TigerSection.vue?vue&type=template&id=7178f05a&scoped=true"
import script from "./TigerSection.vue?vue&type=script&lang=js"
export * from "./TigerSection.vue?vue&type=script&lang=js"
import style0 from "./TigerSection.vue?vue&type=style&index=0&id=7178f05a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7178f05a",
  null
  
)

export default component.exports